import React from 'react';
import PropTypes from 'prop-types';
import Flex from '../../atoms/Flex';
import Box from '../../atoms/Box';

const PriceRating = ({ rating = 0, ...rest }) => {
  if (rating === 0) {
    return null;
  }
  return (
    <Flex {...rest} rating={rating} fontFamily="headings" fontSize="l">
      {Array.apply(0, Array(5)).map((x, i) => (
        <Box key={i} color={rating > i ? 'black' : 'grayscale.400'} mr="2px">
          $
        </Box>
      ))}
    </Flex>
  );
};

PriceRating.propTypes = {
  rating: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  ...Box.propTypes,
};
export default PriceRating;
